import { render, staticRenderFns } from "./ListSettingsWrapper.vue?vue&type=template&id=3493fd4e&scoped=true&"
import script from "./ListSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./ListSettingsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ListSettingsWrapper.vue?vue&type=style&index=0&id=3493fd4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493fd4e",
  null
  
)

export default component.exports